import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,downloadExcelReports} from '../../services/index';
import { Collapse,Popconfirm, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,message,Select,Modal,DatePicker   } from 'antd';
import {  EditOutlined,SafetyCertificateOutlined,DeleteOutlined,DownloadOutlined,WhatsAppOutlined,MailOutlined } from '@ant-design/icons';
import Pagination from "react-js-pagination";
import axios from 'axios';
import $ from 'jquery';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}
const { Option } = Select;

const { RangePicker } = DatePicker;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			email_visible: false,
			sms_visible1: false,
			email_subject: '',
			email_body: '',
			value: '',
			checkedBoxes: [],
			permission: [],
			school_list: [],
			program_list: [],
			academic_year_: [],
			template_list: [],
			sms_template_list: [],
			division_list: [],
			total_self: 0,
			total_franchise: 0,
			is_show: 0,
			aToken: '',
			main_menu: '',
			division: '',
			sub_menu: '',
			academic_year: '',
			student_type: '',
			name: '',
			is_transport: '',
			fees_type: '',
			total_count:0,
			program_id:'',
			is_promote:'',
			email_img:'',
			house:'',
			page: 1,
			perPage: 10,
			docx_loading:false,
			docx_excel:'Document Reports',
			archive_visible:false,
			archive_reason:'',
			tab_name:'',
			template_type: '',
			parameters: [],
			parameters_val: [],
			consent_form_list: [],
			new_date:["",""],
			docs_visible: false,
			consent_id: '',
		}
		this.onChangePage = this.onChangePage.bind(this);
		this.change_pagination = this.change_pagination.bind(this);
		this.change_year = this.change_year.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.onFormGiven = this.onFormGiven.bind(this);
		this.inputChange = this.inputChange.bind(this);
		this.change_house = this.change_house.bind(this);
		this.change_consent = this.change_consent.bind(this);
		this.DateChange = this.DateChange.bind(this);
	}
	
	inputChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	}
	
	onFormGiven=(e,id,kit_id)=>{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		var school_id = storedArray['data'][0]['school_id'];
		var user_id = storedArray['data'][0]['user_id'];
	    var app = {user_id : user_id,school_id:school_id,student_id:id,kit_id:kit_id}
		getData('erp/assign_accessories_student',app).then((result) => {
			let responseJson = result;
			if(responseJson){
				if(result['status'] == 200){
					setTimeout(() => {
					 this.checkData();
					}, 500);
					message.config({ top: 150});
					message.success('Admission Kit Assign Successfully',2);
				}else{
					
				}
			}
		});
	}
	
	onChangePage=(pageNumber)=>{
	    this.setState({ page : pageNumber });
	    setTimeout(() => {
		 this.checkData();
	    }, 500);
	}
	
	change_pagination(event){
		this.setState({
            perPage: event
        })
		setTimeout(() => {
			this.checkData();
		}, 500);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					school_id : storedArray['data'][0]['school_id'],
					permission : permission,
					user_type : user_type,
				});
			}, 50);
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.program_id && params.program_id != null){
				var program_id = params.program_id;
				setTimeout(() => {
					this.openQuantity1(program_id);
				}, 50);
				
				this.setState({program_id: program_id});
			}
			if(params.name && params.name != null){
				var name = params.name;
				this.setState({name: name});
			}
			if(params.student_type && params.student_type != null){
				var student_type = params.student_type;
				this.setState({student_type: student_type});
			}
			if(params.academic_year && params.academic_year != null){
				var academic_year = params.academic_year;
				this.setState({academic_year: academic_year});
			}else{
				const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
				this.setState({ 
					//academic_year : new_acad,
				});
			}
			if(params.admission_form && params.admission_form != null){
				var admission_form = params.admission_form;
				this.setState({admission_form: admission_form});
			}if(params.is_transport && params.is_transport != null){
				var is_transport = params.is_transport;
				this.setState({is_transport: is_transport});
			}if(params.division && params.division != null){
				var division = params.division;
				this.setState({division: division});
			}if(params.fees_type && params.fees_type != null){
				var fees_type = params.fees_type;
				this.setState({fees_type: fees_type});
			}if(params.is_promote && params.is_promote != null){
				var is_promote = params.is_promote;
				this.setState({is_promote: is_promote});
			}if(params.house && params.house != null){
				var house = params.house;
				this.setState({house: house});
			}if(params.tab_name && params.tab_name != null){
				var tab_name = params.tab_name;
				this.setState({tab_name: tab_name});
			}if(params.consent_id && params.consent_id != null){
				var consent_id = params.consent_id;
				this.setState({consent_id: consent_id});
			}
		}
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var type = storedArray['data'][0]['type'];
		var app = {user_id : user_id,school_id:school_id,type:type}
		getData('auth/get_login_token',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					var aToken= result['data'];
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
				else{
					var aToken='null';
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
			}
		});
		getData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
							academic_year : result['current_year'],
						});
						setTimeout(() => {
							this.checkData();
						}, 500);
					}else{
						this.setState({
							academic_year_: [],
						});
					}
				}
			});	
			getData('erp/new_program_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					setTimeout(() => {
						this.setState({
							program_list: result['data'],
						});
					}, 100);	
				}else{
					this.setState({
						program_list: [],
						
					});
				}
				}
			});
			getData('erp/template_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
						this.setState({
							template_list: result['data'],
						});	
				}else{
					this.setState({
						template_list: [],
						
					});
				}
				}
			});
			getData('common/consent_form_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
						this.setState({
							consent_form_list: result['data'],
						});	
				}else{
					this.setState({
						consent_form_list: [],
						
					});
				}
				}
			});
			getData('common/sms_template_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
						this.setState({
							sms_template_list: result['data'],
						});	
				}else{
					this.setState({
						sms_template_list: [],
						
					});
				}
				}
			});
			
			
	}
	
	openQuantity(e){
		this.setState({ program_id: e.target.value,division:'',division_list:[] });
		var app = {user_id : this.state.user_id,program_id:e.target.value,school_id:this.state.school_id,}
		getData('erp/division_list_by_class',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						division_list: result['data'],
					});
				}else{
					this.setState({
						division_list: [],
					});
				}
			}
		});
	} 
	
	openQuantity1(e){
		var app = {user_id : this.state.user_id,program_id:e,school_id:this.state.school_id,division:'',division_list:[]}
		getData('erp/division_list_by_class',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						division_list: result['data'],
					});
				}else{
					this.setState({
						division_list: [],
					});
				}
			}
		});
	}  
	
	change_division(e){
		this.setState({ division: e.target.value });
	}  
	
	handleSubmit(e){
		setTimeout(() => {
			let params = '?student_type='+this.state.student_type+'&academic_year='+this.state.academic_year+'&program_id='+this.state.program_id+'&division='+this.state.division+'&admission_form='+this.state.admission_form+'&name='+this.state.name+'&is_transport='+this.state.is_transport+'&fees_type='+this.state.fees_type+'&is_promote='+this.state.is_promote+'&house='+this.state.house+'&tab_name='+this.state.tab_name+'&new_date='+this.state.new_date+'&consent_id='+this.state.consent_id;
			document.location.search = params;
			this.setState({ page: 1 });
			this.checkData();
		}, 50);
	} 

	SendLink(e){
		if(localStorage.getItem('schoolData')){
			var app = {id : e}
			getData('erp/send_payment_link_student',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					message.config({ top: 150});
					message.success('Link Send Successfully !!',2);
				}else{
					message.config({ top: 150});
					message.error('Link Not Send !!',2);
				}
			});
		}
	} 	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			this.setState({
				school_list: [],
				total_count: 0,
				is_show: 0,
			});
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.program_id && params.program_id != null){
				var program_id = params.program_id;
			}else{
				var program_id = this.state.program_id;
			}
			if(params.name && params.name != null){
				var name = params.name;
			}else{
				var name = this.state.name;
			}
			
			if(params.new_date && params.new_date != null){
				var new_date = params.new_date;
			}else{
				var new_date = this.state.new_date;
			}
			
			if(params.student_type && params.student_type != null){
				var student_type = params.student_type;
			}else{
				var student_type = this.state.student_type;
			}
			if(params.academic_year && params.academic_year != null){
				var academic_year = params.academic_year;
			}else{
				var academic_year = this.state.academic_year;
			}
			if(params.admission_form && params.admission_form != null){
				var admission_form = params.admission_form;
			}else{
				var admission_form = this.state.admission_form;
			}
			if(params.is_transport && params.is_transport != null){
				var is_transport = params.is_transport;
			}else{
				var is_transport = this.state.is_transport;
			}
			if(params.division && params.division != null){
				var division = params.division;
			}else{
				var division = this.state.division;
			}
			if(params.fees_type && params.fees_type != null){
				var fees_type = params.fees_type;
			}else{
				var fees_type = this.state.fees_type;
			}
			if(params.is_promote && params.is_promote != null){
				var is_promote = params.is_promote;
			}else{
				var is_promote = this.state.is_promote;
			}
			if(params.house && params.house != null){
				var house = params.house;
			}else{
				var house = this.state.house;
			}
			if(params.tab_name && params.tab_name != null){
				var tab_name = params.tab_name;
			}else{
				var tab_name = this.state.tab_name;
			}
			if(params.consent_id && params.consent_id != null){
				var consent_id = params.consent_id;
			}else{
				var consent_id = this.state.consent_id;
			}
			
			if(tab_name == 'sibling'){
				var new_url = 'erp/sibling_children_profile_list';
			}else{
				var new_url = 'erp/children_profile_list';
			}
			
			var app = {user_id : user_id,school_id:school_id,page:this.state.page,program_id:program_id,division:division,name:name,student_type:student_type,academic_year:academic_year,admission_form:admission_form,is_transport:is_transport,fees_type:fees_type,is_promote:is_promote,house:house,per_page: this.state.perPage,tab_name: this.state.tab_name,consent_id: this.state.consent_id,date:new_date}
			getData(new_url,app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_count: result['total_school'],
							is_show: 1,
						});
					}else{
						this.setState({
							school_list: [],
							total_count: 0,
							is_show: 1,
						});
					}
				}
			});
	}
    }
	
	Export = () => {
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.program_id && params.program_id != null){
				var program_id = params.program_id;
			}else{
				var program_id = this.state.program_id;
			}
			if(params.name && params.name != null){
				var name = params.name;
			}else{
				var name = this.state.name;
			}
			if(params.student_type && params.student_type != null){
				var student_type = params.student_type;
			}else{
				var student_type = this.state.student_type;
			}
			if(params.academic_year && params.academic_year != null){
				var academic_year = params.academic_year;
			}else{
				var academic_year = this.state.academic_year;
			}
			if(params.admission_form && params.admission_form != null){
				var admission_form = params.admission_form;
			}else{
				var admission_form = this.state.admission_form;
			}
			if(params.is_transport && params.is_transport != null){
				var is_transport = params.is_transport;
			}else{
				var is_transport = this.state.is_transport;
			}
			if(params.division && params.division != null){
				var division = params.division;
			}else{
				var division = this.state.division;
			}
			if(params.fees_type && params.fees_type != null){
				var fees_type = params.fees_type;
			}else{
				var fees_type = this.state.fees_type;
			}
			if(params.is_promote && params.is_promote != null){
				var is_promote = params.is_promote;
			}else{
				var is_promote = this.state.is_promote;
			}
			if(params.house && params.house != null){
				var house = params.house;
			}else{
				var house = this.state.house;
			}
			if(params.tab_name && params.tab_name != null){
				var tab_name = params.tab_name;
			}else{
				var tab_name = this.state.tab_name;
			}
			if(params.consent_id && params.consent_id != null){
				var consent_id = params.consent_id;
			}else{
				var consent_id = this.state.consent_id;
			}
			
			var app = {user_id : user_id,school_id:school_id,page:this.state.page,program_id:program_id,division:division,name:name,student_type:student_type,academic_year:academic_year,admission_form:admission_form,is_transport:is_transport,fees_type:fees_type,is_promote:is_promote,house:house,tab_name:tab_name,consent_id:consent_id}
			downloadExcelReports('Phpspreadsheet/export_filter_student',app,'student_reports').then((result) => {
				let responseJson = result;
				if(responseJson){
					message.config({ top: 150});
					message.success('File Downloaded',2);	
					window.location.reload();
				}
			});
		}
	}
	
	ExportAcount = () => {
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.program_id && params.program_id != null){
				var program_id = params.program_id;
			}else{
				var program_id = this.state.program_id;
			}
			if(params.name && params.name != null){
				var name = params.name;
			}else{
				var name = this.state.name;
			}
			if(params.student_type && params.student_type != null){
				var student_type = params.student_type;
			}else{
				var student_type = this.state.student_type;
			}
			if(params.academic_year && params.academic_year != null){
				var academic_year = params.academic_year;
			}else{
				var academic_year = this.state.academic_year;
			}
			if(params.admission_form && params.admission_form != null){
				var admission_form = params.admission_form;
			}else{
				var admission_form = this.state.admission_form;
			}
			if(params.is_transport && params.is_transport != null){
				var is_transport = params.is_transport;
			}else{
				var is_transport = this.state.is_transport;
			}
			if(params.division && params.division != null){
				var division = params.division;
			}else{
				var division = this.state.division;
			}
			if(params.fees_type && params.fees_type != null){
				var fees_type = params.fees_type;
			}else{
				var fees_type = this.state.fees_type;
			}
			if(params.is_promote && params.is_promote != null){
				var is_promote = params.is_promote;
			}else{
				var is_promote = this.state.is_promote;
			}
			if(params.house && params.house != null){
				var house = params.house;
			}else{
				var house = this.state.house;
			}
			if(params.tab_name && params.tab_name != null){
				var tab_name = params.tab_name;
			}else{
				var tab_name = this.state.tab_name;
			}
			if(params.consent_id && params.consent_id != null){
				var consent_id = params.consent_id;
			}else{
				var consent_id = this.state.consent_id;
			}
			
			var app = {user_id : user_id,school_id:school_id,page:this.state.page,program_id:program_id,division:division,name:name,student_type:student_type,academic_year:academic_year,admission_form:admission_form,is_transport:is_transport,fees_type:fees_type,is_promote:is_promote,house:house,tab_name:tab_name,consent_id:consent_id}
			downloadExcelReports('Phpspreadsheet/export_student_by_fees_form',app,'student_account_reports').then((result) => {
				let responseJson = result;
				if(responseJson){
					message.config({ top: 150});
					message.success('File Downloaded',2);	
					window.location.reload();
				}
			});
		}
	}
	
	ExportAccessories = () => {
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.program_id && params.program_id != null){
				var program_id = params.program_id;
			}else{
				var program_id = this.state.program_id;
			}
			if(params.name && params.name != null){
				var name = params.name;
			}else{
				var name = this.state.name;
			}
			if(params.student_type && params.student_type != null){
				var student_type = params.student_type;
			}else{
				var student_type = this.state.student_type;
			}
			if(params.academic_year && params.academic_year != null){
				var academic_year = params.academic_year;
			}else{
				var academic_year = this.state.academic_year;
			}
			if(params.admission_form && params.admission_form != null){
				var admission_form = params.admission_form;
			}else{
				var admission_form = this.state.admission_form;
			}
			if(params.is_transport && params.is_transport != null){
				var is_transport = params.is_transport;
			}else{
				var is_transport = this.state.is_transport;
			}
			if(params.division && params.division != null){
				var division = params.division;
			}else{
				var division = this.state.division;
			}
			if(params.fees_type && params.fees_type != null){
				var fees_type = params.fees_type;
			}else{
				var fees_type = this.state.fees_type;
			}
			if(params.is_promote && params.is_promote != null){
				var is_promote = params.is_promote;
			}else{
				var is_promote = this.state.is_promote;
			}
			if(params.house && params.house != null){
				var house = params.house;
			}else{
				var house = this.state.house;
			}
			if(params.tab_name && params.tab_name != null){
				var tab_name = params.tab_name;
			}else{
				var tab_name = this.state.tab_name;
			}
			if(params.consent_id && params.consent_id != null){
				var consent_id = params.consent_id;
			}else{
				var consent_id = this.state.consent_id;
			}
			
			var app = {user_id : user_id,school_id:school_id,page:this.state.page,program_id:program_id,division:division,name:name,student_type:student_type,academic_year:academic_year,admission_form:admission_form,is_transport:is_transport,fees_type:fees_type,is_promote:is_promote,house:house,tab_name:tab_name,consent_id:consent_id}
			downloadExcelReports('Phpspreadsheet/export_student_accessories_report',app,'student_accessories_reports').then((result) => {
				let responseJson = result;
				if(responseJson){
					message.config({ top: 150});
					message.success('File Downloaded',2);	
					window.location.reload();
				}
			});
		}
	}
	
	DocumentExportAcount = () => {
  	    if(localStorage.getItem('schoolData')){			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.program_id && params.program_id != null){
				var program_id = params.program_id;
			}else{
				var program_id = this.state.program_id;
			}
			if(params.name && params.name != null){
				var name = params.name;
			}else{
				var name = this.state.name;
			}
			if(params.student_type && params.student_type != null){
				var student_type = params.student_type;
			}else{
				var student_type = this.state.student_type;
			}
			if(params.academic_year && params.academic_year != null){
				var academic_year = params.academic_year;
			}else{
				var academic_year = this.state.academic_year;
			}
			if(params.admission_form && params.admission_form != null){
				var admission_form = params.admission_form;
			}else{
				var admission_form = this.state.admission_form;
			}
			if(params.is_transport && params.is_transport != null){
				var is_transport = params.is_transport;
			}else{
				var is_transport = this.state.is_transport;
			}
			if(params.division && params.division != null){
				var division = params.division;
			}else{
				var division = this.state.division;
			}
			if(params.fees_type && params.fees_type != null){
				var fees_type = params.fees_type;
			}else{
				var fees_type = this.state.fees_type;
			}
			if(params.is_promote && params.is_promote != null){
				var is_promote = params.is_promote;
			}else{
				var is_promote = this.state.is_promote;
			}
			if(params.house && params.house != null){
				var house = params.house;
			}else{
				var house = this.state.house;
			}
			if(params.tab_name && params.tab_name != null){
				var tab_name = params.tab_name;
			}else{
				var tab_name = this.state.tab_name;
			}
			if(params.consent_id && params.consent_id != null){
				var consent_id = params.consent_id;
			}else{
				var consent_id = this.state.consent_id;
			}
			
			
			var app = {user_id : user_id,school_id:school_id,page:this.state.page,program_id:program_id,division:division,name:name,student_type:student_type,academic_year:academic_year,admission_form:admission_form,is_transport:is_transport,fees_type:fees_type,is_promote:is_promote,house:house,tab_name:tab_name,consent_id:consent_id}
			downloadExcelReports('Phpspreadsheet/export_student_document_reports',app,'student_document_reports').then((result) => {
				let responseJson = result;
				if(responseJson){
					message.config({ top: 150});
					message.success('File Downloaded',2);	
					window.location.reload();
				}
			});
		}
	}
	
	DateChange(date, dateString) {
	  this.setState({ new_date: dateString });
	}	
	
	change_year(event){
	this.setState({academic_year: event.target.value});
	}
	change_type(event){
	this.setState({student_type: event.target.value});
	}
	change_admission_form(event){
	this.setState({admission_form: event.target.value});
	}
	change_is_admission(event){
	this.setState({is_promote: event.target.value});
	}
	change_is_transport(event){
	this.setState({is_transport: event.target.value});
	}
	change_fees_type(event){
	this.setState({fees_type: event.target.value});
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	toggleChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);	
		}
		this.setState({checkedBoxes,checked:true,selection_count:checkedBoxes.length});
		console.log(checkedBoxes);
    }
	
	toggleUnChecked = () => {
		this.setState({checkedBoxes:[],checked:false});
    }
  
	handleCheckbox = (e, s) => {
		const checkedBoxes = [...this.state.checkedBoxes];
		if(e.target.checked) {
			checkedBoxes.push(s)
		} else {
			const index = checkedBoxes.findIndex((ch) => ch === s);
			checkedBoxes.splice(index, 1);
		}
		this.setState({checkedBoxes,selection_count:checkedBoxes.length});
	}
	
	deletedata = () => {
		if(this.state.checkedBoxes.length>0){
			if(this.state.archive_reason !=''){
				var app = {user_id : this.state.user_id,id:this.state.checkedBoxes,school_id:this.state.school_id,archive_reason:this.state.archive_reason}
				getData('erp/student_delete',app).then((result) => {
					let responseJson = result;
					if(responseJson){
						if(result['status'] == 200){
							this.setState({
								marketing_delete: result['data'],
							});
							this.checkData();
							message.config({ top: 150});
							this.setState({checkedBoxes:[],archive_reason : '',archive_visible:false});
							message.success('Archive Request Submitted Successfully',2);
						}else{
							this.setState({
								marketing_delete: [],
							});
						}
					}
				});
			}else{
				message.config({ top: 150});
				message.error('Please Enter Remark',2);
			}
			
		}
		else{
			message.config({ top: 150});
			message.error('Please select Student',2);
		}
	}; 
	
	get_selected_stundent(){	 
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var app = {user_id:user_id,school_id:school_id,ids:this.state.checkedBoxes}
			
		getData('erp/get_student_list_by_ids',app).then((result) => {
			let responseJson = result;
			
				if(result['status'] == 200){
					this.setState({
						student_list: result['data'],
						modal_print: true
					});
				}else{
					this.setState({
						student_list: [],
						modal_print: true
					});	
				}
			
		});
			
	}
	
	showSMS = () => {		
		if(this.state.checkedBoxes.length>0){
			this.get_selected_stundent();
			this.setState({
				sms_visible: true,
			})
		}
		else{
			message.config({ top: 150});
			message.error('Please select enquiries',2);
		}
	}

	handleSMSOk = e => {
		this.setState({
			sms_visible: false,
		})
	}

	handleSMSCancel = e => {
		this.setState({
			sms_visible: false,
		})
	}
	
	showSMS1 = () => {		
		if(this.state.checkedBoxes.length>0){
			this.get_selected_stundent();
			this.setState({
				sms_visible1: true,
			})
		}
		else{
			message.config({ top: 150});
			message.error('Please select enquiries',2);
		}
	}

	handleSMSOk1 = e => {
		this.setState({
			sms_visible1: false,
		})
	}

	handleSMSCancel1 = e => {
		this.setState({
			sms_visible1: false,
		})
	}
	
	handleInputChange = (event, id) => {
		// Update the state with the new input value based on the input's ID
		const updatedInputs = this.state.parameters.map((input) =>
		  input.id === id ? { ...input, value: event.target.value } : input
		);
		setTimeout(() => {
			this.setState({ parameters : updatedInputs });
		}, 50);
		
		setTimeout(() => {
			console.log('par:',this.state.parameters);
		}, 50);
	};
	
	handleInputChange1 = (event, id,old_val) => {
		var newStr;
		var str = this.state.template_old_body;
		//newStr = str.replace(old_val,event.target.value);
		var j = 1;
		var new_val = '';
		var fetch_val = '';
		for (var i = 0; i < this.state.parameters.length; i++) {
			new_val = '{#var'+j+'#}';
			fetch_val = 'parameter_'+j;
			var fin_val = document.getElementById(fetch_val).value ;
			console.log('new_val:',new_val);
			newStr = str.replace(new_val,fin_val);
			str = newStr
			j++;
		}
		const updatedInputs = this.state.parameters.map((input) =>
		  input.id === id ? { ...input, value: event.target.value } : input
		);
		//console.log('old_val:',old_val);
		
		setTimeout(() => {
			this.setState({ parameters : updatedInputs });
		}, 50);
		
		setTimeout(() => {
			this.setState({ template_body : newStr });
			console.log('tem:',newStr);
		}, 50);
		
	};
	
	sendSMS= () =>{
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			this.setState({ loading: true });
			var is_multiple_blank = 0
			if(this.state.template_type == 'dynamic'){
				var parameter = [];
				const lenght = this.state.parameters.length;
				for (var i = 0; i < lenght; i++) {
					 console.log('id:',this.state.parameters[i].id)
					 if(this.state.parameters[i].value == ''){
						is_multiple_blank = 1;
					 }
				}
			}
			console.log('Exit : ',is_multiple_blank);
			if(is_multiple_blank == 1){
				this.setState({ loading: false });
				message.config({ top: 150});
				message.error('Please Insert All Parameters !!',5);
			}else{
				var app = {user_id : user_id,school_id:school_id,selected_id:this.state.checkedBoxes,template_id:this.state.template_id,parameters:this.state.parameters,template_type:this.state.template_type}				
				getData('erp/send_whatsapp_to_selected_id',app).then((result) => {
					let responseJson = result;
					setTimeout(() => {
							message.config({ top: 150});
							message.success('Whatsapp Sent Successfully !!',2);
							this.setState({
								sms_visible: false,
								loading: false,
								template_head: '',
								template_body: '',
								template_id: '',
								template_type: '',
								parameters: [],
							})
						}, 1200);
						
						if(result['status'] == 200){
							
						}else{
							
						}
				});
			
			}
			
			
		}
	}	
	
	sendNormalSMS= () =>{
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			this.setState({ loading: true });
			var is_multiple_blank = 0
			if(this.state.template_type == 'dynamic'){
				var parameter = [];
				const lenght = this.state.parameters.length;
				for (var i = 0; i < lenght; i++) {
					 console.log('id:',this.state.parameters[i].id)
					 if(this.state.parameters[i].value == ''){
						is_multiple_blank = 1;
					 }
				}
			}
			console.log('Exit : ',is_multiple_blank);
			if(is_multiple_blank == 1){
				this.setState({ loading: false });
				message.config({ top: 150});
				message.error('Please Insert All Parameters !!',5);
			}else{
				var app = {user_id : user_id,school_id:school_id,selected_id:this.state.checkedBoxes,template_body:this.state.template_body,template_head:this.state.template_head}				
				getData('erp/send_message_to_selected_id',app).then((result) => {
					let responseJson = result;
					setTimeout(() => {
							message.config({ top: 150});
							message.success('Message Sent Successfully !!',2);
							this.setState({
								sms_visible: false,
								loading: false,
								template_head: '',
								template_body: '',
								template_id: '',
								template_type: '',
								parameters: [],
							})
						}, 1200);
						
						if(result['status'] == 200){
							
						}else{
							
						}
				});
			
			}
			
			
		}
	}	

	opentemplate(e){
		this.setState({ template_id: e.target.value });
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var id = e.target.value;
		var app = {user_id:user_id,school_id:school_id,ids:this.state.checkedBoxes,id:id}
			
		getData('erp/template_message_by_id',app).then((result) => {
			let responseJson = result;
			
				if(result['status'] == 200){
					if(result['data'].length > 0){
						this.setState({
							template_head: result['data'][0]['template_head'],
							template_body: result['data'][0]['template_body'],
							template_type: result['data'][0]['template_type'],
							parameters: result['data'][0]['params'],
						});
					}
				}else{
					this.setState({
						template_head: '',
						template_body: '',
						template_type: '',
						parameters: '',
					});	
				}
			
		});
	} 

	opentemplate1(e){
		this.setState({ template_id: e.target.value });
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var id = e.target.value;
		var app = {user_id:user_id,school_id:school_id,ids:this.state.checkedBoxes,id:id}
			
		getData('common/template_text_message_by_id',app).then((result) => {
			let responseJson = result;
			
				if(result['status'] == 200){
					if(result['data'].length > 0){
						this.setState({
							template_head: result['data'][0]['sender_id'],
							template_body: result['data'][0]['template_body'],
							template_old_body: result['data'][0]['template_body'],
							template_type: result['data'][0]['template_type'],
							parameters: result['data'][0]['params'],
						});
					}
				}else{
					this.setState({
						template_head: '',
						template_body: '',
						template_old_body: '',
						template_type: '',
						parameters: '',
					});	
				}
			
		});
	} 	
	
	showEmail = () => {
		if(this.state.checkedBoxes.length>0){
			this.setState({
				email_visible: true,
			})
		}
		else{
			message.config({ top: 150});
			message.error('Please select enquiries',2);
		}
	}
	
	handleEmailOk = e => {
		this.setState({
			email_visible: false,
		})
	}

	handleEmailCancel = e => {
		this.setState({
			email_visible: false,
		})
	}
	
	file_preview1 = (e) => {
		$('#file_preview1').html('1 file selected');
		this.setState({ email_img: e.target.files[0]});
	}
	
	sendEmail= () =>{
  	    if(localStorage.getItem('schoolData')){
			
			if(this.state.email_subject == ''){
				message.config({ top: 150});
				message.error('Please Enter Subject !!',2);
			}else if(this.state.email_body == ''){
				message.config({ top: 150});
				message.error('Please Enter Message !!',2);
			}else{
				var storedArray = JSON.parse(localStorage.getItem("schoolData"));
				var user_id = storedArray['data'][0]['user_id'];
				var school_id = storedArray['data'][0]['school_id'];
				this.setState({ loading: true });
				
				var file_url = '';
				if(this.state.email_img !=''){
					const data = new FormData() ;
					data.append('email_img', this.state.email_img);
					let doc_url = "https://kcisapi.kidzonia.co.in/v1/erp/upload_email_attachment";	
					axios.post(doc_url, data, {
					}).then(response => {
					  console.log('email :',response.data);
					  file_url = response.data;
					  
						var app = {user_id : user_id,school_id:school_id,selected_id:this.state.checkedBoxes,subject:this.state. email_subject,message:this.state.email_body,file_url:file_url}			  
						getData('erp/send_new_email_to_selected_student',app).then((result) => {
							let responseJson = result;
							setTimeout(() => {
								message.config({ top: 150});
								message.success('Email Sent Successfully !!',2);
								this.setState({
									email_visible: false,
									loading: false,
									email_subject: '',
									email_body: '',
									email_img: '',
								});
								$('#file_preview1').html('Choose File');
							}, 1200);
							if(result['status'] == 200){}else{}
						});
					  
					});
					
					
				}else{
					var app = {user_id : user_id,school_id:school_id,selected_id:this.state.checkedBoxes,subject:this.state.email_subject,message:this.state.email_body,file_url:file_url}			  
					getData('erp/send_new_email_to_selected_student',app).then((result) => {
						let responseJson = result;
						setTimeout(() => {
							message.config({ top: 150});
							message.success('Email Sent Successfully !!',2);
							this.setState({
								email_visible: false,
								loading: false,
								email_subject: '',
								email_body: '',
								email_img: '',
							});
							$('#file_preview1').html('Choose File');
						}, 1200);
						if(result['status'] == 200){}else{}
					});
				}
			}
		}
	}
	
	change_house(event){
         this.setState({house: event});
     }
	
	change_consent(event){
         this.setState({consent_id: event});
     }
	 
	showArchive = () => {		
		if(this.state.checkedBoxes.length>0){
			this.setState({
				archive_visible: true,
			})
		}
		else{
			message.config({ top: 150});
			message.error('Please select Student',2);
		}
	}

	handleArchive = e => {
		this.setState({
			archive_visible: false,
		})
	} 
	
	change_tab(event){
		this.setState({tab_name: event,program_id:'',division:'',is_transport:''});
		setTimeout(() => {
			this.handleSubmit();
		}, 50);
	}
	
	showdocs = () => {
		this.setState({
			docs_visible: true,
		})
	}
	
	
	handledocsOk = e => {
		this.setState({
			docs_visible: false,
		})
	}

	handledocsCancel = e => {
		this.setState({
			docs_visible: false,
		})
	}
  

	render()

	{
	const {aToken}=this.state;
	const { size } = this.state;
	
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<>
				<Modal
				 title="Download Document"
				 visible={this.state.docs_visible}
				 className="send-sms"
				 onOk={this.handledocsOk}
				 onCancel={this.handledocsCancel}
				>
					<div class="row">
						<div class="col col-md-12 s12 p-1 mb-20 mt-20 ">
							<table class="table table-striped table-bordered table-hover">
								<thead>
									<tr>	
										<td>Document Name</td>
										<td>Action</td>
									</tr>
								</thead>
								<tbody>
								
								{this.state.consent_form_list.map((item) => (
									<tr>	
										<td>{item.name}</td>
										<td><a href={item.file_url} target="_blank" className="btn btn-primary new-btn mb-0"> View </a></td>
									</tr>
								))}	
									
								</tbody>
							</table>
						</div>
					</div>
				</Modal>
			
				<Modal
				 title="Archive Reason"
				 visible={this.state.archive_visible}
				 className="send-sms"
				 onCancel={this.handleArchive}
				>
				
				
				<div class="col col-md-12 s12 no-padd">
				  <label >Reason</label>
				  <TextArea
					  placeholder="Your Text Goes Here !!"
					  autoSize={{ minRows: 2, maxRows: 6 }}
					  name="archive_reason"
					  value={this.state.archive_reason}
					  onChange={this.inputChange}
					/>
				</div>
				
				<div class="col col-md-12 s12 center mt-20 mb-20">
					<Button className="btn btn-primary mr-2" onClick={this.deletedata.bind(this)} loading={this.state.loading}>Submit</Button>
				</div>
				</Modal>
				
				
				<Modal
				 title="Send Normal Message"
				 visible={this.state.sms_visible1}
				 className="send-sms"
				 onOk={this.handleSMSOk1}
				 onCancel={this.handleSMSCancel1}
				>
				
				<div class="col col-md-12 s12 no-padd">
					<label><b>SELECTED COUNT :</b> {this.state.selection_count}</label><br/>
				</div>
				<div class="col col-md-12 s12 no-padd mb-20">
				 <label ><b>Template</b></label>
					<select  placeholder="Select Template" value={this.state.template_id} name="template_id" id="template_id" className="form-control changeSchool" onChange={this.opentemplate1.bind(this)}>
							<option value="0">Select Template</option>
						{this.state.sms_template_list.map((list)=>(
							<option value={list.id}>{list.name} - {list.sender_id}</option>
						))}	
					</select>
				</div>
				{this.state.template_type == 'dynamic' ? (<>
				<div class="row">
				{this.state.parameters.map((el, i) => 
					<>
						<div class="col col-md-6 s12 mb-20">
							<label ><b>Parameter {el.id}</b></label>
							<input type="text" id={`parameter_${el.id}`} name="parameter[]" onChange={(event) => this.handleInputChange1(event,el.id, el.name)}/>
						</div>
					
					</>
				)}
				</div>
				</>) : (<></>) }
				
				<div class="col col-md-12 s12 no-padd mb-20">
				 <label ><b>Template Body</b></label>
					 <TextArea rows={6}  disabled id="template_msg" value={this.state.template_body}/>
				</div>
				
				<div class="col col-md-12 s12 center mt-20 mb-20">
					<Button className="btn btn-primary mr-2" onClick={this.sendNormalSMS.bind(this)} loading={this.state.loading}>Send Now</Button>
				</div>
				</Modal>
				
				
				<Modal
				 title="Send Whastapp Message"
				 visible={this.state.sms_visible}
				 className="send-sms"
				 onOk={this.handleSMSOk}
				 onCancel={this.handleSMSCancel}
				>
				
				<div class="col col-md-12 s12 no-padd">
					<label><b>SELECTED COUNT :</b> {this.state.selection_count}</label><br/>
				</div>
				<div class="col col-md-12 s12 no-padd mb-20">
				 <label ><b>Template</b></label>
					<select  placeholder="Select Template" value={this.state.template_id} name="template_id" id="template_id" className="form-control changeSchool" onChange={this.opentemplate.bind(this)}>
							<option value="0">Select Template</option>
						{this.state.template_list.map((list)=>(
							<option value={list.template_code}>{list.name} - {list.template_code}</option>
						))}	
					</select>
				</div>
				{this.state.template_type == 'dynamic' ? (<>
				<div class="row">
				{this.state.parameters.map((el, i) => 
					<>
						<div class="col col-md-6 s12 mb-20">
							<label ><b>Parameter {el.id}</b></label>
							<input type="text" id={`parameter_${el.id}`} id="" name="parameter[]" onChange={(event) => this.handleInputChange(event, el.id)}/>
						</div>
					
					</>
				)}
				</div>
				</>) : (<></>) }
				
				<div class="col col-md-12 s12 no-padd mb-20">
				 <label ><b>Template Head</b></label>
					 <input  disabled id="template_msg" value={this.state.template_head}/>
				</div>
				<div class="col col-md-12 s12 no-padd mb-20">
				 <label ><b>Template Body</b></label>
					 <TextArea rows={6}  disabled id="template_msg" value={this.state.template_body}/>
				</div>
				
				<div class="col col-md-12 s12 center mt-20 mb-20">
					<Button className="btn btn-primary mr-2" onClick={this.sendSMS.bind(this)} loading={this.state.loading}>Send Now</Button>
				</div>
				</Modal>
				
				<Modal
				 title="Send Email"
				 visible={this.state.email_visible}
				 className="send-sms"
				 onOk={this.handleEmailOk}
				 onCancel={this.handleEmailCancel}
				>
				
				 <label class="mt-20 error">
					<b>Note : Attachment file size should be less than 5 MB.</b>
				</label>
				
				
				<div class="col col-md-12 s12 no-padd mb-20">
				 <label >Email Subject <span class="error">*</span></label>
				 <input type="text" placeholder="Enter Title here" name="email_subject" value={this.state.email_subject} onChange={this.inputChange} class="form-control"/>
				</div>
				
				<div class="col col-md-12 s12 no-padd">
				  <label >Email Body <span class="error">*</span></label>
				  <TextArea
					  placeholder="Your Text Goes Here !!"
					  autoSize={{ minRows: 2, maxRows: 6 }}
					  name="email_body"
					  value={this.state.email_body}
					  onChange={this.inputChange}
					/>
				</div>
				
				<div class="col col-md-12 s12 no-padd mb-20 mt-20">
					 <label >Email Attachment <span class="error">(Allow only Image, PDF, Excel, and Word files.)</span></label>
					 <div class="col-md-12 no-padd">
					 <label class="ant-btn snd-btn ipt-10" for="email_img" id="file_preview1">Choose File</label>
						<input id="email_img" type="file" accept=".jpg, .jpeg, .png, .gif, .pdf, .xls, .xlsx, .doc, .docx" name="email_img" onChange={this.file_preview1.bind(this)} style={{display: 'none',opacity: '0'}}/>	
					 </div>	
				</div>
				
				
				<div class="col col-md-12 s12 center mt-20 mb-20">
					<Button className="btn btn-primary mr-2" onClick={this.sendEmail.bind(this)} loading={this.state.loading}>Send Now</Button>
				</div>
				</Modal>
				
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i>Child Profile
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Child Profile </li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="card-body">
						<ul class="nav nav-tabs nav-tabs-solid">
            <li class="nav-item"><a href="javascript:void(0)" onClick={this.change_tab.bind(this,'')} class={`nav-link  ${this.state.tab_name == '' ? 'active' : ''}`}>All Student</a></li>
            <li class="nav-item"><a href="javascript:void(0)" onClick={this.change_tab.bind(this,'summer')} class={`nav-link  ${this.state.tab_name == 'summer' ? 'active' : ''}`}>Summer Camp Student</a></li>
            <li class="nav-item"><a href="javascript:void(0)" onClick={this.change_tab.bind(this,'transport')} class={`nav-link  ${this.state.tab_name == 'transport' ? 'active' : ''}`}>Transport Student</a></li>
            <li class="nav-item"><a href="javascript:void(0)" onClick={this.change_tab.bind(this,'sibling')} class={`nav-link  ${this.state.tab_name == 'sibling' ? 'active' : ''}`}>Siblings Student</a></li>
						</ul>
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-12">
					<div class="card">
					<div class="card-body">
						
						<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label style={{paddingTop: '14px'}}><b>Date</b></label>
								<RangePicker className="date-range" onChange={this.DateChange.bind(this)} />
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Academic Year</b></label>
								<select  onChange={this.change_year} className="form-control changeSchool" value={this.state.academic_year}>
									{this.state.academic_year_.map((list) => (
										<option value={list.name}>{list.name}</option>
									))}
								</select>
							</div>
						</div>
						
						{(this.state.tab_name == '') ? (<>
							<div class="col-md-4">
								<div class="row">
								<div class="col-md-6">
								<div class="form-group">
									<label  style={{paddingTop: '8px'}}><b>Class</b></label>
									 <select  placeholder="Select Class" value={this.state.program_id} name="program_id" id="program_id" className="form-control changeSchool" onChange={this.openQuantity.bind(this)}>
										<option value=''>All</option>
										{this.state.program_list.map((list)=>(
											<option value={list.id}>{list.name}</option>
										))}	
									 </select>
								</div>
								</div>
								<div class="col-md-6 ">
								<div class="form-group">
									<label  style={{paddingTop: '8px'}}><b>Division</b></label>
									 <select  placeholder="Select Class" value={this.state.division} name="program_id" id="program_id" className="form-control changeSchool" onChange={this.change_division.bind(this)}>
										<option value=''>All</option>
										{this.state.division_list.map((list)=>(
											<option value={list.id}>{list.name}</option>
										))}	
									 </select>
								</div>
								</div>
								</div>
							</div>
							</>) : (<></>)}
						
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Student Type</b></label>
								 <select  placeholder="Student Type" value={this.state.student_type} name="program_id" id="program_id" className="form-control changeSchool" onChange={this.change_type.bind(this)}>
									<option value="">All</option>
									<option value="Online">Online</option>
									<option value="Offline">Offline</option>
								 </select>
							</div>
						</div>
						
						{(this.state.tab_name == '') ? (<>
							<div class="col-md-2">
								<div class="form-group">
									<label  style={{paddingTop: '8px'}}><b>Transport</b></label>
									 <select  placeholder="Admission Form" value={this.state.is_transport} name="admission_form" id="admission_form" className="form-control changeSchool" onChange={this.change_is_transport.bind(this)}>
										<option value="">All</option>
										<option value="1">Yes</option>
										<option value="0">No</option>
									 </select>
								</div>
							</div>
							</>) : (<></>)}
							
						
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Fees Type</b></label>
								 <select  placeholder="Admission Form" value={this.state.fees_type} name="fees_type" id="fees_type" className="form-control changeSchool" onChange={this.change_fees_type.bind(this)}>
									<option value="">All</option>
									<option value="CBSE">CBSE</option>
									<option value="Cambridge">Cambridge</option>
								 </select>
							</div>
						</div>
						
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Admission</b></label>
								 <select  placeholder="Admission" value={this.state.is_promote} name="is_promote" id="is_promote" className="form-control changeSchool" onChange={this.change_is_admission.bind(this)}>
									<option value="">All</option>
									<option value="1">Old</option>
									<option value="0">New</option>
								 </select>
							</div>
						</div>
						
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Admission Form</b></label>
								 <select  placeholder="Admission" value={this.state.admission_form} name="admission_form" id="admission_form" className="form-control changeSchool" onChange={this.change_admission_form.bind(this)}>
									<option value="">All</option>
									<option value="1">Submitted</option>
									<option value="0">Not Submitted</option>
								 </select>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>House</b></label>
								<Select onChange={this.change_house} value={this.state.house}>
										<Select.Option value="">Select House</Select.Option>
										<Select.Option value="Aarka">Aarka</Select.Option>
										<Select.Option value="Amogh">Amogh</Select.Option>
										<Select.Option value="Abram">Abram</Select.Option>
										<Select.Option value="Ajita">Ajita</Select.Option>
								</Select>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Consent Form</b></label>
								<Select onChange={this.change_consent} value={this.state.consent_id}>
										<Select.Option value="">Select All</Select.Option>
										{this.state.consent_form_list.map((item) => (
											<Select.Option value={item.id}>{item.name}</Select.Option>
										))}	
								</Select>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Student Name</b></label>
								 <input type="text" class="form-control" name="name" placeholder="Search Student" onChange={this.handleSizeChange} value={this.state.name}/>
							</div>
						</div>
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>&nbsp;</b></label>
								 <Button className="btn btn-primary mr-2" style={{display: 'block'}} id="submit_btn" onClick={this.handleSubmit.bind(this)} >Apply</Button>
							</div>
						</div>
						
						</div>
						
					</div>
					</div>
					</div>
				</div>
				
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 form-group">
					 <div class="card">
						<div class="card-body">
						<div class="row mb-10">
						<div class="col-sm-2 col-12 text-left  enquiry-btn mt-10">
							<h4 class="header-title mt-5px">Total Child : {this.state.total_count}</h4>
						</div>
						<div class="col-sm-10 col-12 text-right  enquiry-btn mt-5px">
						
							
							<button onClick={this.showdocs} type="button" className="btn btn-primary new-btn "> Download Document</button>
							
							{(() => {
							if ((this.state.permission.find(element => element == 41)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
								return (
								<>
									<button onClick={this.showSMS} type="button" className="btn btn-primary new-btn "><WhatsAppOutlined />  Send Whastapp</button>
									
									<button onClick={this.showSMS1} type="button" className="btn btn-primary new-btn ">  Send Message</button>
								</>
								)
							}
							})()}
							
							{(() => {
							if ((this.state.permission.find(element => element == 42)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
								return (
								<>
									<button onClick={this.showEmail} type="button" className="btn btn-primary new-btn "><MailOutlined />  Send Email</button>
								</>
								)
							}
							})()}
							
							
							{(() => {
							if (((this.state.permission.find(element => element == 43)) || this.state.user_type == 'admin' || this.state.user_type == 'school') && this.state.tab_name != 'sibling') {
								return (
								<>
									<button className="btn btn-primary new-btn " onClick={this.Export}><DownloadOutlined />Export</button>
								</>
								)
							}
							})()}
							
							{(() => {
							if (((this.state.permission.find(element => element == 48)) || this.state.user_type == 'admin' || this.state.user_type == 'school' ) && this.state.tab_name != 'sibling') {
								return (
								<>
									<button className="btn btn-primary new-btn " onClick={this.ExportAcount}><DownloadOutlined />Account</button>
								</>
								)
							}
							})()}
							
							{(() => {
							if (((this.state.permission.find(element => element == 57)) || this.state.user_type == 'admin' || this.state.user_type == 'school' ) && this.state.tab_name != 'sibling') {
								return (
								<>
									<button className="btn btn-primary new-btn" onClick={this.ExportAccessories}><DownloadOutlined />Accessories</button>
								</>
								)
							}
							})()}
							
							{(() => {
							if (((this.state.permission.find(element => element == 48)) || this.state.user_type == 'admin' || this.state.user_type == 'school' ) && this.state.tab_name != 'sibling') {
								return (
								<>
								  <Button type="default" onClick={this.DocumentExportAcount} loading={this.state.docx_loading}   className="btn btn-primary new-btn "> <DownloadOutlined /> {this.state.docx_excel}</Button>
								</>
								)
							}
							})()}
							
							{((this.state.permission.find(element => element == 63)) || this.state.user_type == 'admin' || this.state.user_type == 'school') && (<>
							
							<Popconfirm
									title="Are you sure you want to archive?"
									onConfirm={this.showArchive}
									okText="Yes"
									cancelText="No"
								  >
									<button className="btn btn-primary new-btn mr-1 right" style={{display: 'block'}}><DeleteOutlined /> Archive</button>
						   </Popconfirm>
							</>)}	
						</div>
						</div>
						
						
						{(() => {
							if (this.state.tab_name == 'sibling') {
								return (
								<>
								  <div class="table-responsive new-table">
								   <table class="table table-striped table-bordered table-hover">
									  <thead>
										
										 <tr>
											<th>
											{(() => {
												if (this.state.checked==true) {
													return (
														<>
														<Checkbox  
															onClick={this.toggleUnChecked.bind(this)}
															checked="checked"
														>
														</Checkbox>
														</>
													)
												}
												else{
													return (
														<>
														<Checkbox  
															onClick={this.toggleChecked.bind(this)}
															checked=""
														>
														</Checkbox>
														</>
													)
												}
											})()}
											</th>
											<th>Action</th>
											{this.state.user_type == 'admin' && (<> <th>Added By</th></>)}
											<th>Admission Date</th>
											<th>Child Name</th>
											<th>Fees Paid</th>
											<th>Document</th>
											<th>Admission Form</th>
											<th>Starter Kit</th>
											<th>Mother Tongue</th>
											<th>Admission</th>
											<th>Accessories</th>
											<th>Fees Type</th>
											<th>Academic Year</th>
											<th>Class</th>
											<th>Division</th>
											<th>Gender</th>
											<th>Birthday</th>
											<th className="nowrap" >House</th>
											<th>Type</th>
											<th>Address</th>
											<th>Emergency</th>
											<th>Upload</th>
											<th>Admission <br/>Kit</th>
											<th>Student  <br/>Aadhar</th>
										 </tr>
									  </thead>
									  <tbody>
									  {(this.state.school_list.length == 0 && this.state.is_show == 1) && (<><tr><td colspan="30" class="text-center">No Children Profile Found</td></tr></>)}
									  {(this.state.school_list.length == 0 && this.state.is_show == 0) && (<><tr><td colspan="30" class="text-center">Please Wait While Loading</td></tr></>)}
									  {this.state.school_list.map((item,index) => (
										<>
										 <tr rowspan={item.child_count}>
											<td colspan="26">{item.sr}. {item.parent_name} <br/><span>{item.parent_mobile}</span></td>
										 </tr>
										 {item.child_data.map((list,index) => (
										 <tr>
											<td> 
											{(list.archive_req == 1) ? (
												<>
													<Checkbox  
														name="checked_id[]"
														value={list.id}
														checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
														onChange={(e) => this.handleCheckbox(e, list.id)}
														disabled
													 >
													</Checkbox>
												</>
											):(
												<>
													<Checkbox  
														name="checked_id[]"
														value={list.id}
														checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
														onChange={(e) => this.handleCheckbox(e, list.id)}
													 >
													</Checkbox>
												</>
											)}
											</td>
											<td>
												<div class="dropright dropright">
													<button type="button" class="btn btn-sm btn-outline-primary btn-rounded btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
														<i class="mdi mdi-dots-vertical"></i>
													</button>
													<ul class="dropdown-menu">
														{(() => {
														if ((this.state.permission.find(element => element == 28)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
															return (
															<>
																<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/edit/${list.id}`} class="dropdown-item"><EditOutlined /> View & Edit</Link></li>
															</>
															)
														}
														})()}
														
														<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/document/${list.id}`} class="dropdown-item"><EditOutlined /> Upload Document</Link></li>
														
														
														
														{(() => {
															if ((this.state.permission.find(element => element == 27)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><a target="_blank" href={`${this.state.main_link}/assign-accessories/${list.id}?t=${aToken}&s=${this.state.school_id}`} class="dropdown-item"><EditOutlined />Assign Starter Kit</a></li>
																	
																	<li><a target="_blank" href={`${this.state.main_link}/assign-class-kit/${list.id}?t=${aToken}&s=${this.state.school_id}`} class="dropdown-item"><EditOutlined />Assign Class Kit</a></li>
																	
																	<li><a target="_blank" href={`${this.state.main_link}/assign-uniform-kit/${list.id}?t=${aToken}&s=${this.state.school_id}`} class="dropdown-item"><EditOutlined />Assign Uniform Kit</a></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 24)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/fees/${list.id}`} class="dropdown-item"><EditOutlined /> Assign Fees</Link></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 33)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/transport/${list.id}`} class="dropdown-item"><EditOutlined /> Assign Transport</Link></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 30)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/view-fees/${list.id}`} class="dropdown-item"><EditOutlined /> View Fees</Link></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 29)) || this.state.permission.find(element => element == 114) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/pay-fees/${list.id}`} class="dropdown-item"><EditOutlined /> Pay Fees</Link></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 62)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student-attendance/${list.id}`} class="dropdown-item"><EditOutlined /> View Attendance</Link></li>
																</>
																)
															}
														})()}
														
														
														{(() => {
															if ((this.state.permission.find(element => element == 77)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><a target="_blank" href={`https://kcisapi.kidzonia.co.in/v1/ReportCard/view_student_id_card/${list.id}`} class="dropdown-item" target="_blank"><EditOutlined /> View ID Card</a></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 82)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><a target="_blank" href={`https://kcisapi.kidzonia.co.in/v1/ReportCard/view_student_escord_card/${list.id}`} class="dropdown-item" target="_blank"><EditOutlined /> View Escord Card</a></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 86)) || this.state.user_type == 'admin' || this.state.user_type == 'school' && list.fees_paid == '1') {
																return (
																<>
																{list.promote == 0 ? (<>
																	<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/promote/${list.id}`} class="dropdown-item"><EditOutlined /> Promote</Link></li>
																</>) : (<></>)}
																	
																</>
																)
															}
														})()}
														
														
														{(() => {
															if ((this.state.permission.find(element => element == 119)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/fees-report/${list.id}`} class="dropdown-item"><EditOutlined /> Fees Graph</Link></li>
																	
																</>
																)
															}
														})()}
														
														
														
														<li><span class="dropdown-item pointer" onClick={this.SendLink.bind(this,list.id)}><EditOutlined /> Send Payment Link</span></li>
													</ul>
												</div>
											</td>
											{this.state.user_type == 'admin' && (<> <td>{list.added_by}</td></>)}
											
											<td>{list.joining_date}</td>
											<td>{list.name} <br/><span>{list.admission_no}</span></td>
											<td className="nowrap center" >
											<span class="house-amogh" style={{'width': 'fit-content'}}>
											{list.fees_paid}%
											</span>
											</td>
											<td><span class="house-aarka" style={{'width': 'fit-content'}}>
											{list.doc_count}
											</span></td>
											<td>{list.admission_form == 1 ? (
											<>Submitted</>
											):(
											<>Not Submitted</>
											)}</td>
											<td className="center nowrap">
												{(() => {
													if (list.starter_view == '1') {
														return (
														<>
															{(() => {
																if (list.starter_assign == '0') {
																	return (
																	<>
																		<Checkbox onChange={(e) => this.onFormGiven(e,list.id,list.starter_id)}>
																		</Checkbox>
																	</>
																	)
																}else{
																	return (
																	<>
																		<span class={list.starter_col} style={{'width': '100px',    'word-break': 'break-word','white-space': 'normal'}}>
																			{list.starter_text}
																		</span>
																	</>
																	)
																}
															})()}
														</>
														)
													}else{
														return (
														<>
														<span class={list.starter_col} style={{'width': '100px',    'word-break': 'break-word','white-space': 'normal'}}>
															{list.starter_text}
														</span>
														</>
														)
													}
												})()}
												
											</td>
											<td>{list.mother_tongue} </td>
											<td className="center" >
												<span class={list.admission_color} style={{'width': 'fit-content'}}>
												{list.admission}
												</span>
												
											</td>
											<td className="center" >
												<span class={list.accessories_color} style={{'width': 'fit-content'}}>
												{list.is_accessories}
												</span>
												
											</td>
											<td>{list.curriculum}</td>
											<td>{list.academic_year}</td>
											<td>{list.program_name}</td>
											<td>{list.division}</td>
											<td>{list.gender}</td>
											<td>{list.birthday}</td>
											<td className="nowrap" >
											<span class={list.house_color}>
											{list.house}
											</span>
											</td>
											<td>{list.type}</td>
											<td>{list.address}</td>
											<td>{list.emergency}</td>
											<td>{list.new_doc_count}</td>
											<td className="center nowrap">
												{(() => {
													if (list.admission_kit_view == '1') {
														return (
														<>
															{(() => {
																if (list.admission_kit_assign == '0') {
																	return (
																	<>
																		<Checkbox onChange={(e) => this.onFormGiven(e,list.id,list.admission_kit_id)}>
																		</Checkbox>
																	</>
																	)
																}else{
																	return (
																	<>
																		<span class={list.admission_kit_col} style={{'width': '100px',    'word-break': 'break-word','white-space': 'normal'}}>
																			{list.admission_kit_text}
																		</span>
																	</>
																	)
																}
															})()}
														</>
														)
													}else{
														return (
														<>
														<span class={list.admission_kit_col} style={{'width': '100px',    'word-break': 'break-word','white-space': 'normal'}}>
															{list.admission_kit_text}
														</span>
														</>
														)
													}
												})()}
												
											</td>
											<td>{(list.student_aadhar != '' ) ? (<><a href={list.student_aadhar} target="_blank">View </a> </>):('-')}</td>
											
										 </tr>
										 ))}
										 </>
										 ))}
										
									  </tbody>
								   </table>
									<div class="fl-right">
										<Pagination
											activePage={this.state.page}
											itemsCountPerPage={this.state.perPage}
											totalItemsCount={this.state.total_count}
											pageRangeDisplayed={3}
											onChange={this.onChangePage.bind(this)}
										/>
									</div>
									
									<Select onChange={this.change_pagination} value={this.state.perPage} className="page-count-change">
										<Select.Option value="10">10</Select.Option>
										<Select.Option value="20">20</Select.Option>
										<Select.Option value="50">50</Select.Option>
										<Select.Option value="100">100</Select.Option>
									</Select>
									
									{this.state.user_type == 'admin' && (<>
									<Link to={`${process.env.PUBLIC_URL}/student/archive`} className="archive-list">Archive Student History</Link>	
									</>)}
								</div>
								</>
								)
							}else{
								return (
								<>
								  <div class="table-responsive new-table">
								   <table class="table table-striped table-bordered table-hover">
									  <thead>
										 <tr>
											<th>
											{(() => {
												if (this.state.checked==true) {
													return (
														<>
														<Checkbox  
															onClick={this.toggleUnChecked.bind(this)}
															checked="checked"
														>
														</Checkbox>
														</>
													)
												}
												else{
													return (
														<>
														<Checkbox  
															onClick={this.toggleChecked.bind(this)}
															checked=""
														>
														</Checkbox>
														</>
													)
												}
											})()}
											</th>
											<th>#</th>
											<th>Action</th>
											{this.state.user_type == 'admin' && (<> <th>Added By</th></>)}
											<th>Admission Date</th>
											<th>Child Name</th>
											<th>Fees Paid</th>
											<th>Document</th>
											<th>Admission Form</th>
											<th>Starter Kit</th>
											<th>Mother Tongue</th>
											<th>Parent</th>
											<th>Parent Occupation</th>
											<th>Admission</th>
											<th>Accessories</th>
											<th>Fees Type</th>
											<th>Academic Year</th>
											<th>Class</th>
											<th>Division</th>
											<th>Gender</th>
											<th>Birthday</th>
											<th className="nowrap" >House</th>
											<th>Type</th>
											<th>Address</th>
											<th>Emergency</th>
											<th>Upload</th>
											<th>Admission <br/>Kit</th>
											<th>Student  <br/>Aadhar</th>
										 </tr>
									  </thead>
									  <tbody>
									  {(this.state.school_list.length == 0 && this.state.is_show == 1) && (<><tr><td colspan="30" class="text-center">No Children Profile Found</td></tr></>)}
									  {(this.state.school_list.length == 0 && this.state.is_show == 0) && (<><tr><td colspan="30" class="text-center">Please Wait While Loading</td></tr></>)}
									  {this.state.school_list.map((list,index) => (
										 <tr>
											<td> 
											{(list.archive_req == 1) ? (
												<>
													<Checkbox  
														name="checked_id[]"
														value={list.id}
														checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
														onChange={(e) => this.handleCheckbox(e, list.id)}
														disabled
													 >
													</Checkbox>
												</>
											):(
												<>
													<Checkbox  
														name="checked_id[]"
														value={list.id}
														checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
														onChange={(e) => this.handleCheckbox(e, list.id)}
													 >
													</Checkbox>
												</>
											)}
											</td>
											<td>{index+1}</td>
											<td>
												<div class="dropright dropright">
													<button type="button" class="btn btn-sm btn-outline-primary btn-rounded btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
														<i class="mdi mdi-dots-vertical"></i>
													</button>
													<ul class="dropdown-menu">
														{(() => {
														if ((this.state.permission.find(element => element == 28)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
															return (
															<>
																<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/edit/${list.id}`} class="dropdown-item"><EditOutlined /> View & Edit</Link></li>
															</>
															)
														}
														})()}
														
														<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/document/${list.id}`} class="dropdown-item"><EditOutlined /> Upload Document</Link></li>
														
														
														
														{(() => {
															if ((this.state.permission.find(element => element == 27)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><a target="_blank" href={`${this.state.main_link}/assign-accessories/${list.id}?t=${aToken}&s=${this.state.school_id}`} class="dropdown-item"><EditOutlined />Assign Starter Kit</a></li>
																	
																	<li><a target="_blank" href={`${this.state.main_link}/assign-class-kit/${list.id}?t=${aToken}&s=${this.state.school_id}`} class="dropdown-item"><EditOutlined />Assign Class Kit</a></li>
																	
																	<li><a target="_blank" href={`${this.state.main_link}/assign-uniform-kit/${list.id}?t=${aToken}&s=${this.state.school_id}`} class="dropdown-item"><EditOutlined />Assign Uniform Kit</a></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 24)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/fees/${list.id}`} class="dropdown-item"><EditOutlined /> Assign Fees</Link></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 33)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/transport/${list.id}`} class="dropdown-item"><EditOutlined /> Assign Transport</Link></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 30)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/view-fees/${list.id}`} class="dropdown-item"><EditOutlined /> View Fees</Link></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 29)) || this.state.permission.find(element => element == 114) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/pay-fees/${list.id}`} class="dropdown-item"><EditOutlined /> Pay Fees</Link></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 62)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student-attendance/${list.id}`} class="dropdown-item"><EditOutlined /> View Attendance</Link></li>
																</>
																)
															}
														})()}
														
														
														{(() => {
															if ((this.state.permission.find(element => element == 77)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><a target="_blank" href={`https://kcisapi.kidzonia.co.in/v1/ReportCard/view_student_id_card/${list.id}`} class="dropdown-item" target="_blank"><EditOutlined /> View ID Card</a></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 82)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																	<li><a target="_blank" href={`https://kcisapi.kidzonia.co.in/v1/ReportCard/view_student_escord_card/${list.id}`} class="dropdown-item" target="_blank"><EditOutlined /> View Escord Card</a></li>
																</>
																)
															}
														})()}
														
														{(() => {
															if ((this.state.permission.find(element => element == 86)) || this.state.user_type == 'admin' || this.state.user_type == 'school' && list.fees_paid == '1') {
																return (
																<>
																{list.promote == 0 ? (<>
																	<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/promote/${list.id}`} class="dropdown-item"><EditOutlined /> Promote</Link></li>
																</>) : (<></>)}
																	
																</>
																)
															}
														})()}
														
														
														{(() => {
															if ((this.state.permission.find(element => element == 119)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
																return (
																<>
																<li><Link target="_blank" to={`${process.env.PUBLIC_URL}/student/fees-report/${list.id}`} class="dropdown-item"><EditOutlined /> Fees Graph</Link></li>
																	
																</>
																)
															}
														})()}
														
														
														
														<li><span class="dropdown-item pointer" onClick={this.SendLink.bind(this,list.id)}><EditOutlined /> Send Payment Link</span></li>
													</ul>
												</div>
											</td>
											{this.state.user_type == 'admin' && (<> <td>{list.added_by}</td></>)}
											
											<td>{list.joining_date}</td>
											<td>{list.name} <br/><span>{list.admission_no}</span></td>
											<td className="nowrap center" >
											<span class="house-amogh" style={{'width': 'fit-content'}}>
											{list.fees_paid}%
											</span>
											</td>
											<td><span class="house-aarka" style={{'width': 'fit-content'}}>
											{list.doc_count}
											</span></td>
											<td>{list.admission_form == 1 ? (
											<>Submitted</>
											):(
											<>Not Submitted</>
											)}</td>
											<td className="center nowrap">
												{(() => {
													if (list.starter_view == '1') {
														return (
														<>
															{(() => {
																if (list.starter_assign == '0') {
																	return (
																	<>
																		<Checkbox onChange={(e) => this.onFormGiven(e,list.id,list.starter_id)}>
																		</Checkbox>
																	</>
																	)
																}else{
																	return (
																	<>
																		<span class={list.starter_col} style={{'width': '100px',    'word-break': 'break-word','white-space': 'normal'}}>
																			{list.starter_text}
																		</span>
																	</>
																	)
																}
															})()}
														</>
														)
													}else{
														return (
														<>
														<span class={list.starter_col} style={{'width': '100px',    'word-break': 'break-word','white-space': 'normal'}}>
															{list.starter_text}
														</span>
														</>
														)
													}
												})()}
												
											</td>
											<td>{list.mother_tongue} </td>
											<td>{list.parent_name} <br/><span>{list.parent_mobile}</span></td>
											<td>{list.parent_occupation} </td>
											<td className="center" >
												<span class={list.admission_color} style={{'width': 'fit-content'}}>
												{list.admission}
												</span>
												
											</td>
											<td className="center" >
												<span class={list.accessories_color} style={{'width': 'fit-content'}}>
												{list.is_accessories}
												</span>
												
											</td>
											<td>{list.curriculum}</td>
											<td>{list.academic_year}</td>
											<td>{list.program_name}</td>
											<td>{list.division}</td>
											<td>{list.gender}</td>
											<td>{list.birthday}</td>
											<td className="nowrap" >
											<span class={list.house_color}>
											{list.house}
											</span>
											</td>
											<td>{list.type}</td>
											<td>{list.address}</td>
											<td>{list.emergency}</td>
											<td>{list.new_doc_count}</td>
											<td className="center nowrap">
												{(() => {
													if (list.admission_kit_view == '1') {
														return (
														<>
															{(() => {
																if (list.admission_kit_assign == '0') {
																	return (
																	<>
																		<Checkbox onChange={(e) => this.onFormGiven(e,list.id,list.admission_kit_id)}>
																		</Checkbox>
																	</>
																	)
																}else{
																	return (
																	<>
																		<span class={list.admission_kit_col} style={{'width': '100px',    'word-break': 'break-word','white-space': 'normal'}}>
																			{list.admission_kit_text}
																		</span>
																	</>
																	)
																}
															})()}
														</>
														)
													}else{
														return (
														<>
														<span class={list.admission_kit_col} style={{'width': '100px',    'word-break': 'break-word','white-space': 'normal'}}>
															{list.admission_kit_text}
														</span>
														</>
														)
													}
												})()}
												
											</td>
											<td>{(list.student_aadhar != '' ) ? (<><a href={list.student_aadhar} target="_blank">View </a> </>):('-')}</td>
											
										 </tr>
										 ))}
										
									  </tbody>
								   </table>
									<div class="fl-right">
										<Pagination
											activePage={this.state.page}
											itemsCountPerPage={this.state.perPage}
											totalItemsCount={this.state.total_count}
											pageRangeDisplayed={3}
											onChange={this.onChangePage.bind(this)}
										/>
									</div>
									
									<Select onChange={this.change_pagination} value={this.state.perPage} className="page-count-change">
										<Select.Option value="10">10</Select.Option>
										<Select.Option value="20">20</Select.Option>
										<Select.Option value="50">50</Select.Option>
										<Select.Option value="100">100</Select.Option>
									</Select>
									
									{this.state.user_type == 'admin' && (<>
									<Link to={`${process.env.PUBLIC_URL}/student/archive`} className="archive-list">Archive Student History</Link>	
									</>)}
								</div>
								</>
								)
							}
						})()}
						
                        
                        </div>
                        </div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
